import spartaStoreUtility from "utilities/global/sparta-store-utility/3.0.3/js/sparta-store-utility";
import "utilities/vendor/fetch/2.0.3/js/fetch";














const DOMAIN_PATTERN = /^https?:\/\/www(?:-(?:(?:dev(?:flex)?)|(?:qa)|(?:cert)|(?:p?review))\d?\.ecnp)?\.bankofamerica.com/gi;

function isJcrManifestTimestamped() {
  return spaParams.buildTimestamp;
}

function isCacheRequired() {
  if(isJcrManifestTimestamped()) {
    return spaParams.siteParams.env === 'local' ? false: true
  }
  return false;
}

function getJcrManifestPath(siteName) {
  if(isJcrManifestTimestamped()) {
    return `/${siteName}/spa-assets/jcr-manifest-${spaParams.buildTimestamp}.json`;
  }
  return `/${siteName}/spa-assets/jcr-manifest.json`;
}

function getJcrPath(pathData, siteName) {
  if(isJcrManifestTimestamped()) {
    return pathData.path.replace(`/${spaParams.siteName}/`, `/${siteName}/`);
  }
  return pathData.path.replace(DOMAIN_PATTERN, '').replace('http://localhost/', '/').replace(`/${spaParams.siteName}/`, `/${siteName}/`);
}

const fetchJson = async (endpoint) => {
  const result = await fetch(endpoint, {

    ...isCacheRequired() ? undefined : { cache: 'no-cache' },
    credentials: 'same-origin',
    headers: {
      'content-type': 'application/json',
    },
    mode: 'same-origin',
  });

  return result.json();
};














export async function resolveDataSources(siteName, dataSources) {


  const spaParams = spartaStoreUtility.getData('spaParams') || spaParams;
  const manifestEndpoint = getJcrManifestPath(siteName);
  const manifest = await fetchJson(manifestEndpoint);
  const jcrs = {};

  Object.keys(dataSources).filter(key => dataSources[key]).forEach((key) => {
    const formattedPath = dataSources[key]
      .replace('{language}', window.sparta.language)
      .replace(/\//g, '-')
      .replace(/.json$/, '');
    const pathData = manifest.jcrs.find(obj => obj.path.includes(formattedPath));

    if (pathData) jcrs[key] = getJcrPath(pathData, siteName);
  });

  return Object.assign({}, dataSources, jcrs);
}
